<template>
    <div>
        <div class="row mt-4 mb-2">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <h1 class="text-primary">Admin beállítások</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1">
            </div>
            <div class="col-lg-10">
                <div id="user-accordion">
                    <div class="card">
                        <div
                            class="card-header"
                            id="user-control-head"
                            data-toggle="collapse"
                            data-target="#user-control-body"
                            aria-expanded="true"
                            aria-controls="user-control-body"
                        >
                            <h5 class="mb-0">
                                Felhasználók kezelése
                            </h5>
                        </div>

                        <div id="user-control-body" class="collapse show" aria-labelledby="user-control-head" data-parent="#user-accordion">
                            <div class="card-body">
                                <UserController></UserController>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="data-accordion">
                    <div class="card">
                        <div
                            class="card-header"
                            id="data-control-head"
                            data-toggle="collapse"
                            data-target="#data-control-body"
                            aria-expanded="true"
                            aria-controls="data-control-body"
                        >
                            <h5 class="mb-0">
                                Általános beállítások
                            </h5>
                        </div>

                        <div id="data-control-body" class="collapse show" aria-labelledby="data-control-head" data-parent="#data-accordion">
                            <div class="card-body">
                                <DictionaryController></DictionaryController>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="email-accordion">
                    <div class="card">
                        <div
                            class="card-header"
                            id="email-control-head"
                            data-toggle="collapse"
                            data-target="#email-control-body"
                            aria-expanded="true"
                            aria-controls="email-control-body"
                        >
                            <h5 class="mb-0">
                                Általános beállítások
                            </h5>
                        </div>

                        <div id="email-control-body" class="collapse show" aria-labelledby="email-control-head" data-parent="#email-accordion">
                            <div class="card-body">
                                <EmailNotificationController></EmailNotificationController>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserController from '@/components/admin/UserController';
    import DictionaryController from '@/components/admin/DictionaryController';
    import EmailNotificationController from '@/components/admin/EmailNotificationController';

    export default{
        name: 'AdminPage',
        data(){
            return {

            }
        },
        components: {
            UserController,
            DictionaryController,
            EmailNotificationController
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/AdminPage.vue